<script lang="ts">
import {Options, Vue} from "vue-class-component";
import {ConsentValue, getStoredConsent, setConsent} from "@/gtag";

@Options({
  data() {
    return {
      visible: false
    };
  },
  mounted() {
    const stored = getStoredConsent();
    if (stored === null) {
      this.visible = true;
      return;
    }
    // Az index.html mindig "denied" alapállapottal indul, ezért a korábbi döntést
    // minden oldalbetöltéskor újra el kell játszani a gtag felé.
    setConsent(stored);
  },
  methods: {
    decide(value: ConsentValue): void {
      setConsent(value);
      this.visible = false;
    }
  }
})
export default class CookieConsent extends Vue {
}
</script>

<template>
  <div v-if="visible" class="cookie-consent">
    <v-card class="hk-card cookie-consent__card pa-5">
      <div class="cookie-consent__text">
        <div class="cookie-consent__title">Sütik használata</div>
        <p class="cookie-consent__body">
          Hirdetéseink teljesítményének mérésére sütiket használnánk. Ezek nélkül az oldal
          ugyanúgy működik – csak nem látjuk, hogy a hirdetéseink elérik-e a céljukat.
        </p>
      </div>
      <div class="cookie-consent__actions">
        <v-btn variant="text" color="secondary" @click="decide('denied')">Elutasítom</v-btn>
        <v-btn color="primary" variant="flat" @click="decide('granted')">Elfogadom</v-btn>
      </div>
    </v-card>
  </div>
</template>

<style scoped>
.cookie-consent {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  justify-content: center;
  padding: 1rem;
  pointer-events: none;
}

.cookie-consent__card {
  pointer-events: auto;
  width: 100%;
  max-width: 760px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.5rem;
  box-shadow: var(--hk-shadow-lg) !important;
}

.cookie-consent__title {
  font-family: 'Playfair Display', Georgia, serif;
  font-weight: 700;
  font-size: 1.15rem;
  color: var(--hk-ink);
  margin-bottom: 0.25rem;
}

.cookie-consent__body {
  font-size: 0.92rem;
  line-height: 1.45;
  color: var(--hk-ink-soft);
  margin: 0;
}

.cookie-consent__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

@media (max-width: 700px) {
  .cookie-consent__card {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .cookie-consent__actions {
    justify-content: flex-end;
  }
}
</style>
